﻿
export function formatToTwoDecimals(num) {
    const renderedPrice = num.toFixed(2).replace('.', ',');
    return renderedPrice;
}

export function formatToPrecent(value) {
    const valueAsPrecent = value * 100;
    return trimToInteger(valueAsPrecent) + '%';
}

export function trimToInteger(value) {
    return Math.round(value);
}